<!-- 搜索功能页 -->
<template>
  <div class="page-content">
    <c-header pageName="搜索"></c-header>
    <div class="nav-tool">
      <section :class="selectStatus===0?'activity':''" @click="statusChange(0)">库位</section>
<!--      <section :class="selectStatus===1?'activity':''" @click="statusChange(1)">板号</section>-->
      <section :class="selectStatus===2?'activity':''" @click="statusChange(2)">国际条码</section>
    </div>
    <div class="search-content flex-wrap" v-show="!showResult">
      <div class="content-item flex">
        <section
          class="flex"
          v-if="ownWarehouseList.length>0"
          @click="handleSelectWarehouse"
        >{{ selectWarehouse.warehouseName ? selectWarehouse.warehouseName : "请选择仓库" }}
        </section>
        <section class="flex" v-else>{{ selectWarehouse.warehouseName }}</section>
        <van-icon name="arrow-down" style="margin-right: 10px"/>
      </div>
      <div class="content-item flex">
        <section class="search-tool">
          <van-field v-model="searchKey" autofocus/>
          <span @click="onSearch">{{ buttonText }}</span>
        </section>
      </div>
    </div>
    <div class="search-result flex" v-show="showResult">
      <div class="storageLocation flex-wrap" v-show="this.selectStatus===0">
        <div class="header flex-wrap">
          <section>仓库 : {{ selectWarehouse.warehouseName }}</section>
          <section>库位 : {{ searchKey }}</section>
          <section>明细条数 : {{ storageLocation.stockCount }}</section>
          <section>总数量 : {{ storageLocation.stockQty }}</section>
        </div>
        <div class="order flex-wrap">
          <div
            class="order-item flex-wrap"
            v-for="(item,index) in storageLocation.stockInfos"
            :key="index"
          >
            <section>商家 : {{ item.shipper.name }}</section>
            <section>商品名称 : {{ item.productName }}</section>
            <section>国际条码 : {{ item.barCode }}</section>
            <section>可用库存 : {{ item.stockDataOne.unassignedQty || 0 }}</section>
<!--            <section>项次 : {{ item.itemSn }}</section>-->
            <section>规格 : {{ item.specVal }}</section>
            <section>效期 : {{ item.productDate|dateSub }} ~ {{ item.invalidDate|dateSub }}</section>
            <section>板号 : {{ item.bandSn }}</section>
            <section>不良品状态 :&nbsp;
              <span :style="item.stockDataOne.defectFlag ? 'color: #F56C6C' : 'color: #67C23A'">
              {{ item.stockDataOne.defectFlag ? "不良品" : "良品" }}
            </span>
            </section>
            <section>库存状态 :&nbsp;
              <div v-for="status in StockStatus()" :key="status.value">
                <span v-if="status.value === item.stockStatus" :style="`color: ${status.color}`"> {{status.label }}</span>
              </div>
            </section>
            <section>商品状态 :&nbsp;
              <div v-for="status in ProductStatus()" :key="status.value">
                <span v-if="status.value === item.stockDataOne.productStatus" :style="`color: ${status.color}`"> {{status.label }}</span>
              </div>
            </section>
            <section class="tools" @click="handlePrint(item)">
              <span>打印</span>
            </section>
          </div>
        </div>
      </div>
      <div
        class="ban flex-wrap"
        v-if="this.selectStatus===1 "
      >
        <section>商家 : {{ stockInfo.shipper.name }}</section>
        <section>商品名称 : {{ stockInfo.productName }}</section>
        <section>国际条码 : {{ stockInfo.barCode }}</section>
        <section>可用库存 : {{ stockInfo.stockDataOne.unassignedQty || 0 }}</section>
<!--        <section>项次 : {{ stockInfo.itemSn }}</section>-->
        <section>规格 : {{ stockInfo.specVal }}</section>
        <section>效期 : {{ stockInfo.productDate|dateSub }} ~ {{ stockInfo.invalidDate|dateSub }}</section>
        <section>板号 : {{ stockInfo.bandSn }}</section>
        <section>不良品状态 :&nbsp;
          <span :style="stockInfo.stockDataOne.defectFlag ? 'color: #F56C6C' : 'color: #67C23A'">
              {{ stockInfo.stockDataOne.defectFlag ? "不良品" : "良品" }}
            </span>
        </section>
        <section>库存状态 :&nbsp;
          <div v-for="status in StockStatus()" :key="status.value">
            <span v-if="status.value === stockInfo.stockStatus" :style="`color: ${status.color}`"> {{status.label }}</span>
          </div>
        </section>
        <section class="tools"  @click="handlePrint(stockInfo)">
          <span>打印</span>
        </section>
      </div>
      <div
        class="barcode flex-wrap"
        v-if="this.selectStatus===2 "
      >
        <div class="goods-item flex-wrap" v-for="(item,index) in products" :key="index">
          <div class="right">
            <section>货主 : {{ item.shipper.name }}</section>
            <section>商品名称 : {{ item.productName }}</section>
            <section>国际条码 : {{ item.barCode }}</section>
            <section>商品编码 : {{ item.productCode }}</section>
            <section>可用库存 : {{ item.qty || 0 }}</section>
            <section>规格 : {{ item.specVal }}</section>
          </div>
          <div class="left" @click="goGoodsBanDetail(item.productId)">
            <i class="iconfont xiangyou"></i>
          </div>
        </div>
      </div>
    </div>
    <van-picker
      show-toolbar
      v-show="showWarehousePicker"
      :columns="warehousePicker"
      @confirm="onWarehouseConfirm"
      @cancel="showWarehousePicker = false"
    />
  </div>
</template>

<script>
import Header from "../components/headerNav.vue";
import StorageUtil from "../util/storage.js";
import {ProductStatus, StockStatus} from "../common/constant";
import DataFormat from "../util/dataFormat";
import Utils from "../util/utils";

export default {
  data() {
    return {
      selectStatus: 0,
      searchKey: "", // 搜索
      ownWarehouseList: [], // 用户绑定的仓库
      selectWarehouse: {}, // 选中的仓库
      warehousePicker: [],
      showWarehousePicker: false,
      buttonText: "扫描库位",
      showResult: false, // 显示搜索结果
      storageLocation: {},
      stockInfo: {
        shipper: {
          name: '',
        },

      },
      products: []
    };
  },
  components: {
    "c-header": Header
  },
  mounted() {
    this.member = StorageUtil.getLocalStorage("member");
    this.getMemberWarehouseList();
  },
  methods: {
    StockStatus() {
      return StockStatus
    },
    ProductStatus() {
      return ProductStatus
    },
    // 导航切换
    statusChange(value) {
      this.selectStatus = value;
      this.showResult = false;
      this.searchKey = "";
      switch (value) {
        case 1:
          this.buttonText = "扫描板号";
          break;
        case 2:
          this.buttonText = "扫描国际条码";
          break;
        default:
          this.buttonText = "扫描库位";
          break;
      }
    },
    // 查询用户绑定的仓库
    getMemberWarehouseList() {
      this.$post(this.URL.getWarehouseList, {
        ids: this.member.ownWarehouseIds
      }).then(res => {
        if (res.success) {
          this.ownWarehouseList = res.data;
          this.warehousePicker = this.ownWarehouseList.map(item => {
            return item.warehouseName;
          });
          if (this.ownWarehouseList.length === 1) {
            this.selectWarehouse = this.ownWarehouseList[0];
          }
        } else {
          this.$toast.fail(res.message);
        }
      });
    },
    // 点击弹出选中框
    handleSelectWarehouse() {
      this.showWarehousePicker = true;
    },
    // 仓库选择
    onWarehouseConfirm(value, index) {
      this.selectWarehouse = this.ownWarehouseList[index];
      this.showWarehousePicker = false;
    },

    // 搜索
    onSearch() {
      if (!this.searchKey) {
        this.$toast.fail("请填写搜索内容");
      }
      let requestUrl = "";
      let param = {
        id: this.selectWarehouse.id
      };
      if (this.selectStatus === 0) {
        requestUrl = this.URL.findBySlCode;
        param.strValue = this.searchKey;
      } else if (this.selectStatus === 1) {
        requestUrl = this.URL.findByBandSn;
        param.strValue = this.searchKey;
      } else {
        requestUrl = this.URL.findByBarCode;
        param.strValue = this.searchKey;
      }
      this.$post(requestUrl, param).then(res => {
        if (res.success) {
          this.showResult = true;
          if (this.selectStatus === 0) {
            this.storageLocation = res.data;
          } else if (this.selectStatus === 1) {
            this.stockInfo = res.data;
          } else {
            this.products = res.data;
          }
        } else {
          this.$toast.fail(res.message);
        }
      });
    },
    //打印
    handlePrint(item) {
      let data = "1," + Utils.formatStr(item.productName, 16, '...') + "," + item.bandSn + ",国际条码:" + item.barCode + ",货主:" +  Utils.formatStr(item.shipper.name, 8, '...') + ",失效日期:" + DataFormat.formatDate(item.invalidDate, "YYYY-MM-DD")
      window.printSupport.share(data)
    },
    // 查看商品在板详情
    goGoodsBanDetail(id) {
      this.$router.push({path: "/searchGoodsDetail", query: {"productId": id}})
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-tool {
  display: flex;
  width: 100%;
  height: 3rem;
  background-color: #dc6350;
  padding: 0 3rem;
  align-items: center;
  justify-content: center;

  section {
    display: inline-flex;
    width: 7rem;
    justify-content: center;
    border: 1px solid #fff;
    height: 1.8rem;
    align-items: center;
    font-size: 0.9rem;
    color: white;
  }

  .activity {
    background-color: white;
    color: #dc6350;
  }

  section:first-child {
    border-top-left-radius: 0.2rem;
    border-bottom-left-radius: 0.2rem;
  }

  section:last-child {
    border-top-right-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
  }
}

.search-content {
  padding: 1rem;
  font-size: 0.9rem;
  color: #444;

  .content-item {
    height: 2.5rem;
    align-items: center;
    border: 1px solid #f0f0f0;
    border-radius: 0.5rem;
  }

  .content-item:first-child {
    margin: 1rem 0 1.5rem 0;
    padding-left: 1rem;
  }

  .search-tool {
    display: flex;
    width: 100%;
    height: 2.5rem;
    align-items: center;
    border-radius: 0.5rem;
    padding-left: 1rem;
    margin: 0.3rem 0;

    .van-cell {
      display: inline-flex;
      align-items: center;
      height: 2.2rem;
      padding: 0;
    }

    .van-cell:not(:last-child)::after {
      border-bottom: none;
    }

    span {
      display: inline-flex;
      height: 2.5rem;
      align-items: center;
      justify-content: center;
      width: 8rem;
      border-left: 1px solid #f0f0f0;
    }
  }
}

.search-result {
  padding: 1rem;
  font-size: 0.85rem;
  color: #444;

  section {
    display: flex;
    width: 100%;
    height: 1.8rem;
    align-items: center;
    padding: 0 0.5rem;
  }

  .header {
    border: 1px solid #dc6350;
    border-radius: 0.5rem;
  }

  .order-item {
    font-size: 0.8rem;
    border-bottom: 1px dashed #f0f0f0;
    padding: 0.5rem 0;

    section {
      height: 1.5rem;
    }
  }

  .goods-item {
    border-bottom: 1px dashed #f0f0f0;
    font-size: 0.8rem;

    .right {
      display: inline-flex;
      width: 90%;
      flex-wrap: wrap;
    }

    .left {
      display: inline-flex;
      width: 10%;
      align-items: center;
      justify-content: center;

      i {
        font-size: 1.3rem;
        color: #dc6350;
      }
    }
  }

  .tools {
    height: 1.8rem;
    justify-content: flex-end;

    span {
      display: inline-flex;
      width: 4rem;
      height: 1.8rem;
      background-color: #dc6350;
      color: #fff;
      align-items: center;
      justify-content: center;
      border-radius: 0.3rem;
    }
  }

  .ban {
    font-size: 0.8rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/Search.vue